// ReturnActions.tsx
import React from "react";
import { Button } from "../ui/button";
import { Download, Trash2 } from "lucide-react";
import { Entities, ReturnStatus, Roles } from "@/enums";
import { PRIMARY_COLOR, SECONDARY_COLOR } from "@/constants/constants";
import { IReturn } from "@/interfaces/Return";

interface ReturnActionsProps {
  return_: IReturn;
  roles: string;
  handlers: {
    onLitigeClick: (e: React.MouseEvent) => void;
    onConsultLitigeClick: (e: React.MouseEvent) => void;
    onDeleteClick: (e: React.MouseEvent) => void;
    onDownloadClick: (e: React.MouseEvent) => void;
    onBLDownloadClick: (e: React.MouseEvent) => void;
  };
}

export const ReturnActions: React.FC<ReturnActionsProps> = ({
  return_,
  roles,
  handlers,
}) => {
  // Define button configs with conditions and rendering details
  const buttons = [
    {
      id: "consultLitige",
      condition: return_.islitige,
      render: () => (
        <Button
          className="flex items-center justify-center space-x-1 border rounded-md px-2 py-1 h-8 border-red-500 hover:bg-red-100 text-red-500 hover:text-red-600"
          variant="outline"
          onClick={handlers.onConsultLitigeClick}
        >
          <span className="text-xs font-semibold">Consulter litige</span>
        </Button>
      ),
    },
    {
      id: "download",
      condition: return_.url && [Roles.WAREHOUSE_ROLE,Roles.HUB_ROLE].includes(roles as Roles) ,
      render: () => (
        <Button
          className="flex items-center justify-center w-8 h-8 border rounded-md bg-white hover:bg-teal-50"
          style={{ borderColor: SECONDARY_COLOR }}
          onClick={handlers.onDownloadClick}
        >
          <Download className="w-4 h-4" style={{ color: PRIMARY_COLOR }} />
        </Button>
      ),
    },
    {
      id: "delete",
      condition:
        roles.includes(Roles.WAREHOUSE_ROLE) &&
        (return_.statutId === ReturnStatus.CREATED ||
          (return_.statutId === ReturnStatus.RECEIVED_BY_HUB &&
            return_.entityId === Entities.WAREHOUSE_ID)),
      render: () => (
        <Button
          className="flex items-center justify-center w-8 h-8 border rounded-md bg-white hover:bg-red-50 border-red-500"
          onClick={handlers.onDeleteClick}
        >
          <Trash2 className="w-4 h-4 text-red-500" />
        </Button>
      ),
    },
    {
      id: "litige",
      condition:
        return_.statutId === ReturnStatus.RECEIVED_BY_SELLER &&
        roles.includes(Roles.SELLER_ROLE),
      render: () => (
        <Button
          className="flex items-center justify-center space-x-1 border rounded-md px-2 py-1 h-8 border-red-500 hover:bg-red-100 text-red-500 hover:text-red-600"
          variant="outline"
          onClick={handlers.onLitigeClick}
        >
          <span className="text-xs font-semibold">Litige</span>
        </Button>
      ),
    },
    {
      id: "BLDownload",
      condition:
        return_.urlCachte &&
        roles.includes(Roles.WAREHOUSE_ROLE || Roles.HUB_ROLE),
      render: () => (
        <Button
          className="flex items-center justify-center w-8 h-8 border rounded-md bg-white hover:bg-teal-50"
          style={{ borderColor: SECONDARY_COLOR }}
          onClick={handlers.onBLDownloadClick}
        >
          <span className="text-sm font-semibold text-gray-900">BL</span>
        </Button>
      ),
    },
  ];

  return (
    <div className="flex items-center space-x-2">
      {buttons
        .filter((button) => button.condition)
        .map((button) => (
          <React.Fragment key={button.id}>{button.render()}</React.Fragment>
        ))}
    </div>
  );
};
